export default `
    --z-index-modal-backdrop: 9000;
    --z-index-modal-container: calc(var(--z-index-modal-backdrop) + 100);
    --z-index-modal-body: calc(var(--z-index-modal-backdrop) + 200);
    --z-index-modal-header: calc(var(--z-index-modal-backdrop) + 300);
    --z-index-modal-footer: calc(var(--z-index-modal-backdrop) + 300);
    --z-index-modal-gimmick-bar: 1;

    --z-index-navigation-fixed-footer:   1800;
    --z-index-navigation-fixed-sidebar:   1900;
    --z-index-navigation-topbar:   2000;
    --z-index-navigation-topbar-btn:   2100;
    
    --z-index-navigation-sidebar:   3000;
    --z-index-navigation-sidebar-backdrop: 2090;
    --z-index-navigation-sidebar-footer:   3010;

    --z-index-navigation-sidebar-tooltip-menu:   4030;
    --z-index-navigation-sidebar-tooltip-menu-backdrop: 4020;

    // === App Elements ==
    --z-index-table-header-row: 100;
    --z-index-footer: 100;
    --z-index-table-fixed-header: 200;
    --z-index-table-header: 91;
    --z-index-table-mask: 210;
    --z-index-table-tooltip: 250;


    --z-index-sticky-main-section: 3000;
      --mask-z-index: 100;



// Eventualy delete al this!! 
--z-index-top-bar: 20;
--z-index-table: 2;
--z-index-dropdown: 800;
--z-index-dropdown-btn: 8;
--z-index-modal: 1;
--z-index-grid-element: 1;

`;
